(function() {
	'use strict'

	angular
		.module( "ATMGurus" )
		.service( "LookupService", LookupService);

	LookupService.$inject = ["ApiQuery", "FormService"];

	function LookupService(ApiQuery, FormService) {
		var _this = this;

		// client code has to change that
		this.endpoint = undefined;

		this.results = undefined;

		this.search = function(code) {
			if (!this.endpoint) throw 'endpoint cannot must be specified';
			this.status.loading = true
			// null the resutls
			this.results = undefined;
			FormService.post('support/' + this.endpoint, {code: code})
				.then(function(response) {
					this.status.loading  = false;
					this.results = response.data
				}.bind(this))
				.catch(function(reason) {
					this.status.loading = false;
				}.bind(this))
		},


		this.status = {
			loading: false
		}

	}

})()


// WEBPACK FOOTER //
// ./src/app/services/Lookup.js